export default "__VITE_ASSET__DJPiCXvh__"